import { PhoneNumberUtil } from 'google-libphonenumber';

const phoneNumberParser = PhoneNumberUtil.getInstance();

function parsePhoneNumber(phoneNumber) {
  if (phoneNumber) {
    let parsedPhoneNumber;

    try {
      parsedPhoneNumber = phoneNumberParser.parse(`+${phoneNumber.replace(/^0+/, '')}`);
    } catch (error) {
      if (phoneNumber?.length > 4) {
        console.warn(`Phone number parsing error for: '${phoneNumber}' - ${error.message}`);
      }
    }

    return {
      countryCode: parsedPhoneNumber ? `+${parsedPhoneNumber.getCountryCode()}` : '',
      number: parsedPhoneNumber ? `${parsedPhoneNumber.getNationalNumber()}` : ''
    };
  }

  return { countryCode: '', number: '' };
}

function formatPhoneNumber(unformattedPhoneNumber) {
  if (unformattedPhoneNumber?.number) {
    const { countryCode, number: phoneNumber } = unformattedPhoneNumber;

    return `${countryCode.replace(/^\++/, '')}${phoneNumber}`;
  }

  return null;
}

export { parsePhoneNumber, formatPhoneNumber };
